import axios from "axios";
import {
    GET_ALERTS,
    TOGGLE_ALERT,
    DELETE_ALERT,
    ADD_TRACK_RECORD,
    ADD_ALERT,
    ADD_NEWS_FEED,
    GET_NEWS_FEEDS,
    UPLOAD_NEWS_FEED_IMAGES,
    GET_NEWS_FEEDS_STATS, CLEAR_NEWS_FEED, GET_LATEST_NEWS_FEEDS
} from "./types";
import {showLoading,hideLoading} from 'react-redux-loading-bar';
import {handleResponse,negativeResponse} from '../Utils/ResponseManager';

export const addNewsFeed = requestData => dispatch => {
    dispatch(showLoading());
    let formData = new FormData();
    formData.append('feedFile', requestData.feedFile);
    formData.append("date", requestData.date);
    formData.append("title", requestData.title);
    axios.post('/api/news-feed/upload',formData,
        {
            headers:{
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(res => {
            dispatch(hideLoading());
            dispatch(handleResponse(res.data,ADD_NEWS_FEED));
        }).catch(err => {
        dispatch(negativeResponse(err));
    });
};

export const uploadImages = images => dispatch => {
    dispatch(showLoading());
    let formData = new FormData();
    for(let image of images){
        formData.append('images', image);
    }
    axios.post('/api/news-feed/upload/images',formData,
        {
            headers:{
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(res => {
            dispatch(hideLoading());
            dispatch(handleResponse(res.data,UPLOAD_NEWS_FEED_IMAGES));
        }).catch(err => {
        dispatch(negativeResponse(err));
    });
};

export const getNewsFeed = requestData => dispatch => {
    dispatch(showLoading());
    axios.get("/api/news-feed",requestData)
        .then(res => {
            dispatch(hideLoading());
            dispatch(handleResponse(res.data,GET_NEWS_FEEDS));
        }).catch(err => {
            dispatch(negativeResponse(err));
        });
};

export const getLatestNewsFeed = requestData => dispatch => {
    dispatch(showLoading());
    axios.get("/api/news-feed/latest",requestData)
        .then(res => {
            dispatch(hideLoading());
            dispatch(handleResponse(res.data,GET_LATEST_NEWS_FEEDS));
        }).catch(err => {
            dispatch(negativeResponse(err));
        });
};

export const getNewsFeedStats = requestData => dispatch => {
    dispatch(showLoading());
    axios.get("/api/news-feed/upload/stats",requestData)
        .then(res => {
            dispatch(hideLoading());
            dispatch(handleResponse(res.data,GET_NEWS_FEEDS_STATS));
        }).catch(err => {
            dispatch(negativeResponse(err));
        });
};

export const clearUploadDirectory = requestData => dispatch => {
    dispatch(showLoading());
    axios.delete("/api/news-feed/upload",requestData)
        .then(res => {
            dispatch(hideLoading());
            dispatch(handleResponse(res.data,CLEAR_NEWS_FEED));
        }).catch(err => {
            dispatch(negativeResponse(err));
        });
};





